import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const analyticsLayoutDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};

export type AnalyticsLayoutUniDriver = ReturnType<
  typeof analyticsLayoutDriverFactory
>;
